import React from "react";
import { cn } from "@/lib/utils";

const initialsOf = (name = "") => {
    return name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((s) => s[0].toUpperCase())
        .join("");
};

export const InitialsAvatar = ({ name, className, dataTestId = "user-avatar" }) => {
    return (
        <span
            className={cn(
                "inline-flex h-9 w-9 select-none items-center justify-center rounded-full bg-primary text-sm font-semibold text-primary-foreground shadow-sm",
                className
            )}
            data-testid={dataTestId}
            aria-label={name}
        >
            {initialsOf(name) || "?"}
        </span>
    );
};
